<template>
  <section class="settings-index">
    <settings-list :items="items" />
  </section>
</template>

<script>
  import { mapState } from 'vuex';

  import external from '@/helpers/mixins/external';

  import SettingsList from '@/components/Settings/List.vue';

  import accountsIcon from '@/assets/images/illustrations/settings/accounts.svg';
  import storesIcon from '@/assets/images/illustrations/settings/stores.svg';
  import commercialIcon from '@/assets/images/illustrations/settings/commercial.svg';
  import profileIcon from '@/assets/images/illustrations/settings/profile.svg';
  import usersIcon from '@/assets/images/illustrations/settings/users.svg';
  import vehiclesIcon from '@/assets/images/illustrations/settings/vehicles.svg';
  import alertsIcon from '@/assets/images/illustrations/settings/alerts.svg';
  import aboutIcon from '@/assets/images/illustrations/settings/tables.svg';
  import showroomIcon from '@/assets/images/illustrations/settings/showroom.svg';

  export default {
    name: 'SettingsIndex',
    components: {
      SettingsList,
    },
    mixins: [external],
    computed: {
      ...mapState([
        'auth',
      ]),

      user() {
        return this.auth.user || {};
      },

      items() {
        const {
          account,
          id,
        } = this.user;

        if (!id) {
          return [];
        }

        const items = [{
          title: 'Conta',
          description: 'Gerencie as informações da sua conta, como metas do grupo ou envio de SMS quando propostas forem aprovadas',
          icon: accountsIcon,
          url: {
            name: 'accounts-read',
            params: {
              id: account.id,
            },
          },
          permissions: ['admin', 'account_manager', 'account_admin'],
        }, {
          title: 'Lojas e equipes',
          description: 'Crie suas lojas, organize usuários em equipes de venda e estabeleça suas metas commerciais',
          icon: storesIcon,
          url: {
            name: 'account-stores',
            params: {
              id: account.id,
            },
          },
          permissions: ['admin', 'account_manager', 'account_admin', 'store_manager'],
        }, {
          title: 'Controle comercial',
          description: 'Gerencie preços de veículos, porcentagens de entrada e comissões',
          icon: commercialIcon,
          url: {
            name: 'settings-commercial',
          },
          features: ['simulations'],
          permissions: ['admin', 'account_manager', 'account_admin', 'store_manager'],
        }, {
          title: 'Showroom Digital',
          description: 'Estilize e gerencie o Showroom das suas lojas',
          icon: showroomIcon,
          url: {
            name: 'stores-public-simulator-settings-list',
            params: {
              id: account.id,
            },
          },
          features: ['public_simulator'],
          permissions: ['admin', 'account_manager', 'account_admin', 'store_manager'],
        }, {
          title: 'Perfil',
          description: 'Adicione, remova ou edite informações de seu perfil, como e-mail, foto ou senha',
          icon: profileIcon,
          url: {
            name: 'users-read',
            params: {
              id,
            },
          },
          features: [],
          permissions: ['admin', 'account_manager', 'account_admin', 'sales_manager', 'store_manager', 'salesman', 'credit', 'bank_operator'],
        }, {
          title: 'Usuários',
          description: 'Cadastre, ative, desative ou edite informações de usuários em sua conta',
          icon: usersIcon,
          url: {
            name: 'users-list',
          },
          features: [],
          permissions: ['admin', 'account_manager', 'account_admin', 'sales_manager', 'store_manager', 'salesman', 'credit', 'bank_operator'],
        }, {
          title: 'Veículos',
          description: 'Adicione, edite ou exclua veículos da sua conta',
          icon: vehiclesIcon,
          url: {
            name: 'settings-vehicles',
          },
          features: [],
          permissions: ['admin'],
        }, {
          title: 'Alertas',
          description: 'Adicione avisos sobre o mau-funcionamento do sistema',
          icon: alertsIcon,
          url: {
            name: 'settings-system-alerts',
          },
          features: [],
          permissions: ['admin'],
        }, {
          title: 'Sobre',
          description: 'Política de privacidade e termos de uso',
          icon: aboutIcon,
          url: {
            name: 'settings-about',
          },
          features: [],
          permissions: ['admin', 'account_manager', 'account_admin', 'sales_manager', 'store_manager', 'salesman', 'credit', 'bank_operator'],
        }];

        return items.filter(this.external);
      },
    },
  };
</script>

<style lang="scss" scoped></style>
